
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiUpIec as ObiUpIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-up-iec.js';
 
 
 

 
 export const ObiUpIec = createComponent({
   react: React,
   tagName: 'obi-up-iec',
   elementClass: ObiUpIecElement,
   events: {
     
   }
  });
 
 